<template>
  <div class="bg1" ref="setH">
    <div class="manageBox">
      <div class="searchBox" style="padding:0px 5px 20px">
        <div class="toolBar">
          <el-input
            v-model="search.ipName"
            size="small"
            style="width: 150px; margin: 0 10px 0 0"
            placeholder="请输入内容"
          ></el-input>
          <el-button type="primary" @click="getBaiMingDan" size="small"
            >查询</el-button
          >
          <el-button
            type="primary"
            @click="addNew"
            size="small"
            style="float: right; margin-right: 15px"
            >新增</el-button
          >
        </div>
      </div>

      <div class="contentBox">
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column
            prop="ip"
            label="IP地址"
            width="300"
          ></el-table-column>
          <el-table-column prop="remark" label="说明"></el-table-column>
          <el-table-column label="操作" fixed="right" width="180">
            <template slot-scope="scope">
              <!-- <el-button type="text" @click="watchDetail(scope.row)" size="small">查看详情</el-button> -->
              <el-button type="text" @click="shanchu(scope.row)" size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="pages">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="pages.pageAll"
            :page-size="pages.pageSize"
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增白名单" :visible.sync="dialogVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="ip地址">
          <el-input v-model="form.ip" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="ip说明">
          <el-input v-model="form.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="baocun">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增白名单" :visible.sync="dialogVisible" width="30%">
      <el-form :model="form">
        <el-form-item label="ip地址">
          <el-input v-model="form.ip" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="ip说明">
          <el-input v-model="form.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="baocun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Whitelist",
  data() {
    return {
      ccc: "白名单",
      tabH: 0,
      search: {
        ipName: "",
        page: 1,
        size: 10,
      },
      dialogVisible: false,
      tableData: [],
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      form: {
        ip: "",
        remark: "",
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 100;
    });
    this.getBaiMingDan();
  },
  methods: {
    // 获取白名单列表
    getBaiMingDan() {
      let urlLink = `/server/white/load/list`;
      let param = {
        ip: this.search.ipName,
        page: this.search.page,
        size: this.search.size,
      };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取白名单列表", res);
        // this.conditions.xueduanList = res;
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
    },
    // 记载详情
    watchDetail(obg) {
      let urlLink = `/server/white/load/detail`;
      let param = { ip: obg.ip };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("查看详情", res);
        // if(res){
        //   this.$message({
        //    message:'删除成功！',
        //    type:'success'
        //  })
        //   this.getBaiMingDan();
        // }
      });
    },
    // 添加新IP
    addNew() {
      this.dialogVisible = true;
      this.form.ip = "";
      this.form.remark = "";
    },
    // 删除条目
    shanchu(obg) {
      let urlLink = `/server/white/remove`;
      let param = { ip: obg.ip };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("删除返回", res);
        if (res) {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.getBaiMingDan();
        }
      });
    },
    // 保存IP
    baocun() {
      if (this.isValidIP(this.form.ip) == false) {
        this.$message({
          message: "请输入正确的IP地址",
          type: "warning",
        });
        return;
      }
      let urlLink = `/server/white/save`;
      this.$ajax.post(urlLink, this.form).then((res) => {
        console.log("保存新增", res);
        if (res) {
          this.$message({
            message: "保存成功！",
            type: "success",
          });
          this.dialogVisible = false;
          this.getBaiMingDan();
        }
      });
    },
    // IP验证
    isValidIP(ip) {
      var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      return reg.test(ip);
    },
    // 分页变动
    handleCurrentChange(val) {
      this.search.page = val;
      this.getBaiMingDan();
    },
    handleSizeChange(val) {
      this.search.size = val;
      this.search.page = 1;
      this.getBaiMingDan();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/manage/whiteList.vue